import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AuthService, AuthType } from "./auth.service";
import { environment } from "../../../environments/environment";
import { catchError, map } from "rxjs/operators";
import { throwError } from "rxjs/internal/observable/throwError";
import { MatLegacySnackBar as MatSnackBar } from "@angular/material/legacy-snack-bar";
import { Observable } from "rxjs/internal/Observable";
import { AlertService } from "../alert/alert.service";

@Injectable({
  providedIn: "root"
})
export class FileService {
  constructor(
    private http: HttpClient,
    private snackBar: MatSnackBar,
    private authService: AuthService,
    private alertService:AlertService,
  ) {}

  uploadFile(data: FormData, subId?: any): Observable<any> {
    const url = `/api/file`;
    const options = {
      headers: this.authService.buildAuthHeader(AuthType.Idenedi)
    };
    return this.http.post(environment.apiHost + url, data, options).pipe(
      map(data => {
        return {
          url: data,
          subId
        };
      }),
      catchError(errorRes => {
        this.alertService.error("ExdrCommon.ServerError");
        throw errorRes;
      })
    );
  }
}
